// extracted by mini-css-extract-plugin
export var card = "_sh-0";